import { render } from "./AuctionTotalView.vue?vue&type=template&id=63dfe3f2&scoped=true"
import script from "./AuctionTotalView.vue?vue&type=script&lang=js"
export * from "./AuctionTotalView.vue?vue&type=script&lang=js"

import "./AuctionTotalView.vue?vue&type=style&index=0&id=63dfe3f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dfe3f2"]])

export default __exports__